module.exports = __webpack_public_path__ + "img/logo.5ecb8486.png";